import React, {useContext} from "react";
import {View, Text, Image} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";

const PrintDocumentSignature = (props) => {
  const {styles, isContractSign, receiptSignature, userInfo, assignQuotePopupCustomer, locale} = props;
  const printContext = useContext(PrintDocumentContext);

  const customerName = assignQuotePopupCustomer
    ? assignQuotePopupCustomer.fullName
    : userInfo.firstName + (userInfo.lastName ? (" " + userInfo.lastName) : "");

  const formattedDate = (new Date().toLocaleString(locale,
    {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'}
  )).replace(/,/g, "");

  return (
    <View style={styles.signature} wrap={false}>
      <View style={[styles.section, styles.sectionLeft]}>
        <Text style={[styles.signatureValue, styles.black]}>{customerName}</Text>
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.name"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionCenter]}>
        <Text style={[styles.signatureValue, styles.black]}>{formattedDate}</Text>
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.date"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionRight]} isSignField={true}>
        {receiptSignature && !isContractSign ? <Image style={styles.signatureImage} src={receiptSignature} /> : null}
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.signature"]}</Text>
      </View>
    </View>
  )
};

PrintDocumentSignature.propTypes = {
  styles: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  userInfo: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  isContractSign: PropTypes.bool,
  receiptSignature: PropTypes.string,
};

export default PrintDocumentSignature
